import baseApi from "./base"
import { BaseResponse } from "./types/common"
import { GetCaptcha1Response, GetCaptcha1Request } from "./types/captcha"
import { RefreshCaptcha1Request, RefreshCaptcha1Response } from "./types/refreshCaptcha"
import { ResendOtpRequest, ResendOtpResponse } from "./types/resendOtp"
import { Step1Request, Step1Response } from "./types/step1"
import { Step2Request, Step2Response } from "./types/step2"
import { SendSmsRequest } from "./types/sendSms"

const api = baseApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    getToken: builder.mutation<BaseResponse, string>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body,
          functionCode: "MERC004",
          NextTransactionUrl: "Facebook/SocialMediaPortalCreateSession/GetTokenByTckn1",
          TokenSessionId: "ABCDEFABCDEFABCDEFABCDEFABCDEFABCDEF"
        }
      }),
      transformResponse: (response: string) =>  JSON.parse(response)
    }),
    getCaptcha: builder.mutation<GetCaptcha1Response, GetCaptcha1Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          posCekNo: body.posCekNo,
          TokenSessionId: body.TokenSessionId,
          NextTransactionUrl: "Facebook/WebPosCek/GetCaptcha1"
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    refreshCaptcha: builder.mutation<RefreshCaptcha1Response, RefreshCaptcha1Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          posCekNo: body.posCekNo,
          NextTransactionUrl: "Facebook/WebPosCek/RefreshCaptcha1",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    resendOtp: builder.mutation<ResendOtpResponse, ResendOtpRequest>({
      query: (body) => ({
        url: "/",
        method: "POST",
        body: {
          posCekNo: body.posCekNo,
          TokenSessionId: body.TokenSessionId,
          NextTransactionUrl: "Facebook/WebPosCek/ResendOtp1",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    step1: builder.mutation<Step1Response, Step1Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          posCekNo: body.posCekNo,
          last4Number: body.phoneLast4Number,
          captcha: body.captcha,
          NextTransactionUrl: "Facebook/WebPosCek/Step1",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),    
    step2: builder.mutation<Step2Response, Step2Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          posCekNo: body.posCekNo,
          otp: body.otp,
          NextTransactionUrl: "Facebook/WebPosCek/Step2",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    sendSms: builder.mutation<BaseResponse, SendSmsRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          posCekNo: body.posCekNo,
          NextTransactionUrl: "Facebook/WebPosCek/SendSms1",
          TokenSessionId: body.TokenSessionId
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    })
  })
})

export const {
  useGetTokenMutation,
  useGetCaptchaMutation,
  useRefreshCaptchaMutation,
  useResendOtpMutation,
  useStep1Mutation,  
  useStep2Mutation,
  useSendSmsMutation,
} = api

export default api
